"use client"

import Script from "next/script"

/**
 * Renders nothing until NEXT_PUBLIC_GA_MEASUREMENT_ID is set — safe to keep
 * mounted unconditionally in the tree. Once you create a GA4 property and
 * add the env var (locally in .env.local, and in Vercel for production),
 * this starts sending pageviews with no other code changes needed.
 */
export function GoogleAnalytics() {
  const measurementId = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID
  if (!measurementId) return null

  return (
    <>
      <Script src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`} strategy="afterInteractive" />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${measurementId}');
        `}
      </Script>
    </>
  )
}
